import { render, staticRenderFns } from "./Pfout.vue?vue&type=template&id=4c023b98&scoped=true"
import script from "./Pfout.vue?vue&type=script&lang=js"
export * from "./Pfout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c023b98",
  null
  
)

export default component.exports